import React from 'react';
import { Box, Button, Card, CardContent, Container, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const PageActionButton = ({ children, ...props }) => (
  <Button variant='contained' startIcon={<AddIcon />} sx={{ textTransform: 'none', whiteSpace: 'nowrap' }} {...props}>
    {children}
  </Button>
);

const PageShell = ({ title, subtitle, actions, children }) => (
  <Container maxWidth={false} sx={{ my: 4, px: { xs: 2, md: 3 }, width: '100%', maxWidth: '100%' }}>
    <Card variant='outlined' sx={{ borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.06)', p: 2 }}>
      <CardContent>
        <Box display='flex' justifyContent='space-between' alignItems='center' gap={2} mb={3} flexWrap='wrap'>
          <Box minWidth={0}>
            <Typography variant='h5' fontWeight='bold' textTransform='uppercase'>
              {title}
            </Typography>
            {subtitle ? (
              <Typography variant='body2' color='text.secondary' mt={0.5}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
          {actions ? (
            <Box display='flex' alignItems='center' gap={2} flexWrap='wrap'>
              {actions}
            </Box>
          ) : null}
        </Box>
        {children}
      </CardContent>
    </Card>
  </Container>
);

export default PageShell;
